module.exports = __webpack_public_path__ + "img/鸿新云公众号_二维码.28c0ac55.png";